import { Link } from "@inertiajs/react";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar.tsx";
import { bizminer_app_root_path } from "@/routes";
import type { BizminerOrganizationDisplay } from "@/types/serializers";

export const OrganizationWithLogo = ({
  organization,
}: {
  organization?: BizminerOrganizationDisplay | null;
}) => {
  if (!organization) return null;
  const organizationName =
    typeof organization.name === "string" && organization.name.length > 0
      ? organization.name
      : "Organization";

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton size="lg" asChild className="hover:bg-transparent active:bg-transparent data-[active=true]:bg-transparent data-[state=open]:hover:bg-transparent">
          <Link href={bizminer_app_root_path()}>
            {organization.logo_thumb_url && (
              <div className="flex size-12 items-center justify-center rounded-lg border border-border/50 bg-muted/30 p-2">
                <img
                  src={organization.logo_thumb_url}
                  alt={`${organizationName} logo`}
                  className="max-h-full max-w-full object-contain"
                />
              </div>
            )}
            <span className="text-xl font-bold truncate">
              {organizationName}
            </span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};
